export const features = {
	cart: false,
	marker: true,
};
